import React from 'react';
import { formatNumber } from '../utils';

const CountUp = ({
  start = 0,
  end,
  duration = 25
}) => {
  const [counter, setCounter] = React.useState(start);
  const ref = React.useRef(0);
  const increaseRate = 25;
  let timeOut;
  const increment = (end - start) / increaseRate;

  const updateCounter = () => {
    if (ref.current <= end) {
      const result = Math.ceil(ref.current + increment);
      if (result > end) return setCounter(end);
      setCounter(result);
      ref.current = result;
    }

    timeOut && clearTimeout(timeOut);
    timeOut = setTimeout(updateCounter, duration);
  };

  React.useEffect(() => {
    if (ref.current > end) ref.current = 0;
    updateCounter();
    return () => {
      clearTimeout(timeOut);
    };
  }, [end]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, formatNumber(counter));
};

export default CountUp;